export default "__VITE_ASSET__BsNmRfn4__"